import { Service } from 'typedi';
import { BaseService, IBaseService, ServerResponse } from '../../../core/services/BaseService';
import { CompareDateModel, EstimateDetailsModel, SpcUrlModel} from './calculator/SpcModels';
import { Appl } from '../../../core/Appl';

export interface ISpcService extends IBaseService {

  getMemberInfoByUrlAsync(model: SpcUrlModel): Promise<ServerResponse>;
  getSpcLovsAsync(): Promise<ServerResponse>;
  getMembershipTierByEmployerAsync(mbrEmployer?:string): Promise<ServerResponse>;

  getSavedEstimatesAsync(memberId: string): Promise<ServerResponse>;
  getFinalEstimateAsync(spcTypeSubId: number): Promise<ServerResponse>;
  deleteSavedEstimatesAsync(spcTypeSubId: number): Promise<ServerResponse>;
  getPurchaseCalculatorDetailsByMemberIdAsync(memberId: string,spcTypeSubmissionId?:number,spcTypeId?:number): Promise<ServerResponse>;
  
  createOrUpdateEstimateDetailsAsync(model: EstimateDetailsModel): Promise<ServerResponse>;
  deleteEstimationDetailAsync(spcReqId: number,spcTypeId:number): Promise<ServerResponse>;
  deleteAllEstimationDetailsAsync(spcTypeSubId: number): Promise<ServerResponse>;
  acceptEstimationTermsAsync(spcTypeSubId:number,spcTypeId:number): Promise<ServerResponse>;
  getLeaveHours(date: CompareDateModel): Promise<ServerResponse>;
  // beginNewEstimateAsync(memberId: string, spcTypeId: number): Promise<ServerResponse>;
}

@Service() // eslint-disable-next-line
export class SpcService extends BaseService implements ISpcService {
  constructor() {
    super(`${Appl.Setting.Services.PurchaseCalculatiorUrl}`);
  }

  public async getMemberInfoByUrlAsync(model: SpcUrlModel): Promise<ServerResponse> {
    try {
      const response = await this.client.post('/spc/purchase-calculator/member-info-by-url', model);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }
  
  public async getSpcLovsAsync(): Promise<ServerResponse> {
    try {
      const response = await this.client.get(`/spc/purchase-calculator/spc-lovs`);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

    public async getMembershipTierByEmployerAsync(mbrEmployer?:string): Promise<ServerResponse> {
    try {
      const response = await this.client.get(`/spc/purchase-calculator/membership-tier-by-employer/${mbrEmployer}`);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }
  public async getSavedEstimatesAsync(memberId: string): Promise<ServerResponse> {
    try {
      const response = await this.client.get(`/spc/purchase-calculator/saved-estimates-by-member-id/${memberId}`);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async getFinalEstimateAsync(spcTypeSubId: number): Promise<ServerResponse> {
    try {
      const response = await this.client.get(`/spc/purchase-calculator/get-final-estimate/${spcTypeSubId}`);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async deleteSavedEstimatesAsync(spcTypeSubId: number): Promise<ServerResponse> {
    try {
      const response = await this.client.delete(`/spc/purchase-calculator/delete-saved-estimate/${spcTypeSubId}`);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async getPurchaseCalculatorDetailsByMemberIdAsync(memberId: string,spcTypeSubId?:number,spcTypeId?:number): Promise<ServerResponse> {
    try {
      if(spcTypeSubId===undefined){
        spcTypeSubId = 0;
      }
      const response = await this.client.get(`/spc/purchase-calculator/details-by-member-id/${memberId}/${spcTypeSubId}/${spcTypeId}`);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

   public async createOrUpdateEstimateDetailsAsync(model: EstimateDetailsModel): Promise<ServerResponse> {
    try {
      const response = await this.client.post(`/spc/purchase-calculator/create-or-update-estimation-details`, model);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async deleteEstimationDetailAsync(spcReqId: number,spcTypeId:number): Promise<ServerResponse> {
    try {
      const response = await this.client.delete(`/spc/purchase-calculator/delete-estimation-details/${spcReqId}/${spcTypeId}`);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async deleteAllEstimationDetailsAsync(spcTypeSubId: number): Promise<ServerResponse> {
    try {
      const response = await this.client.delete(`/spc/purchase-calculator/delete-all-estimation-details/${spcTypeSubId}`);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async acceptEstimationTermsAsync(spcTypeSubId:number,spcTypeId:number): Promise<ServerResponse> {
    try {
      const response = await this.client.post(`/spc/purchase-calculator/accept-estimation-terms/${spcTypeSubId}/${spcTypeId}`, {});
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async getLeaveHours(date: CompareDateModel): Promise<ServerResponse> {
    try {
      const response = await this.client.post(`/spc/purchase-calculator/leave-hours`, date);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

}
